import U2000InputText from "../../../../u2000Core/components/formControls/input/U2000InputText";
import { NS } from "../../../U3143";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import type { TFunction } from "i18next";

// Typage des props du composant
interface U3143DistrictCadastreComponentProps<T extends Record<string, any>> {
  formStateHandlers: U2000FormStateHandlers<T>;
  t: TFunction;
}

function U3143DistrictCadastreBody<T extends Record<string, any>>({ formStateHandlers, t }: U3143DistrictCadastreComponentProps<T>) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <U2000InputText fieldName="codeDistrict" label={t("lblCodeDistrict", { ns: NS })} formStateHandlers={formStateHandlers} />
      <U2000InputText fieldName="propertyDistrict" label={t("lblPropertyDistrict", { ns: NS })} formStateHandlers={formStateHandlers} />
    </div>
  );
}

export default U3143DistrictCadastreBody;
